<template>
<v-container fluid>
    <my-product-category/>
</v-container>
</template>

<script>
export default {
components: {
    'my-product-category': () => import ('@/components/Product_Category'),
    
    
  },
}
</script>

<style>

</style>